// Company branding configuration
// These values are populated from environment variables at build time

export const companyConfig = {
  name: process.env.NEXT_PUBLIC_COMPANY_NAME || '',
  domain: process.env.NEXT_PUBLIC_COMPANY_DOMAIN || '',
  twitter: process.env.NEXT_PUBLIC_COMPANY_TWITTER || '',

  // Derived values
  get logoUrl() {
    return '/images/call2fly-logo.svg';
  },

  get faviconUrl() {
    return '/favicon.svg';
  },

  get websiteUrl() {
    return `https://${this.domain}`;
  },
};
